/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ roundName: NonNullable<unknown> }} Keen_Gold_Bear_WalkInputs */

const en_keen_gold_bear_walk = /** @type {(inputs: Keen_Gold_Bear_WalkInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Round ${i?.roundName}`)
};

const de_keen_gold_bear_walk = /** @type {(inputs: Keen_Gold_Bear_WalkInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Runde ${i?.roundName}`)
};

/**
* | output |
* | --- |
* | "Round {roundName}" |
*
* @param {Keen_Gold_Bear_WalkInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const keen_gold_bear_walk = /** @type {((inputs: Keen_Gold_Bear_WalkInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Keen_Gold_Bear_WalkInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_keen_gold_bear_walk(inputs)
	return de_keen_gold_bear_walk(inputs)
});